export const TOW_DECIMALS = 2;
export const FOUR_DECIMALS = 4;
// round function : pour limiter le nombre des chiffres après la virgule


